var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoaiOperator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 1008,
    viewBox: "0 0 1008 1008",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7612_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1002,
    y: 1002,
    width: 1000,
    height: 1000,
    rx: 225,
    transform: "rotate(180 1002 1002)",
    fill: "url(#paint0_linear_7612_12)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.317 203.673C155.056 227.64 154.383 251.579 153.491 275.663C152.305 307.686 153.64 338.851 153.64 370.857C153.64 396.143 153.64 421.429 153.64 446.714C153.64 479.773 158.016 510.939 161.077 543.693C166.487 601.583 178.219 660.378 189.933 717.273C192.363 729.08 193.28 740.816 195.882 752.524C197.585 760.188 194.722 767.295 199.154 773.943",
    stroke: "white",
    strokeWidth: 131,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.414 243.833C190.179 253.598 197.809 266.571 206.146 277.597C232.32 312.213 259.273 346.685 286.466 380.525C313.595 414.286 343.889 445.17 371.099 478.843C389.318 501.389 403.914 525.989 421.373 549.048C440.561 574.391 460.353 598.492 477.448 625.203C486.305 639.042 499.242 654.142 504.37 669.528",
    stroke: "white",
    strokeWidth: 131,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M750.684 176.9C742.58 178.926 734.875 200.054 730.753 206.351C716.222 228.551 701.298 250.578 688.511 273.879C659.087 327.495 632.734 382.452 601.944 435.411C576.333 479.463 551.255 524.89 528.466 570.467C519.123 589.154 510.322 609.732 499.016 626.691",
    stroke: "white",
    strokeWidth: 131,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M745.328 136.74C752.519 137.639 758.706 167.183 760.202 173.033C768.938 207.183 781.736 240.322 790.694 274.474C812.004 355.718 829.447 436.471 842.307 519.598C854.731 599.914 863.13 680.479 863.13 761.896C863.13 781.901 860.453 802.966 860.453 822.135",
    stroke: "white",
    strokeWidth: 131,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7612_12",
    x: 0,
    y: 0,
    width: 1008,
    height: 1008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7612_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7612_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7612_12",
    x1: 1502,
    y1: 1002,
    x2: 1502,
    y2: 2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#52B788"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoaiOperator);
export default __webpack_public_path__ + "static/media/moai-operator.2cede80b546f3b4814a69966bca76016.svg";
export { ForwardRef as ReactComponent };